import { useState } from "react";
import styled from "styled-components";

import { ActiveViewSwitchContent } from "@/components/layout/Sidebar/SidebarControls/ActiveViewSwitch/ActiveViewSwitchContent";
import { SidebarControlContent } from "@/components/layout/Sidebar/SidebarControls/SidebarControl/SidebarControlContent/SidebarControlContent";
import { SidebarControlTrigger } from "@/components/layout/Sidebar/SidebarControls/SidebarControl/SidebarControlTrigger";
import { SidebarControlTriggerContent } from "@/components/layout/Sidebar/SidebarControls/SidebarControl/SidebarControlTrigger/SidebarControlTriggerContent";
import { SidebarControlTriggerTitle } from "@/components/layout/Sidebar/SidebarControls/SidebarControl/SidebarControlTrigger/SidebarControlTriggerTitle";
import {
    SIDEBAR_TRIGGER_SUBTITLE_CLASS,
    SIDEBAR_TRIGGER_TITLE_CLASS,
} from "@/components/layout/Sidebar/SidebarControls/SidebarControl/SidebarControlTrigger/sidebar-trigger.consts";
import { Popover } from "@/components/ui/Popover";
import { Icon } from "@/components/ui-deprecated";
import { viewDefinitions } from "@/features/views";
import type { View } from "@/features/views";
import { useAppSelector } from "@/store";

const SidebarControlStyled = styled.div`
    position: relative;
`;

const ActiveViewSwitch = () => {
    const activeView = useAppSelector((state) => state.user.activeView);
    const [isOpen, setIsOpen] = useState(false);

    if (activeView === null || !(activeView in viewDefinitions)) return null;

    const subtitle = viewDefinitions[activeView as View].label;

    return (
        <Popover open={isOpen} onOpenChange={setIsOpen}>
            <SidebarControlStyled>
                <Popover.Trigger asChild>
                    <SidebarControlTrigger>
                        <SidebarControlTriggerContent>
                            <Icon icon={"lely-icon-human"} />
                            <SidebarControlTriggerTitle>
                                <span className={SIDEBAR_TRIGGER_TITLE_CLASS}>Active Role</span>
                                <span className={SIDEBAR_TRIGGER_SUBTITLE_CLASS} title={subtitle}>
                                    {subtitle}
                                </span>
                            </SidebarControlTriggerTitle>
                        </SidebarControlTriggerContent>
                        <Icon icon={"angle-right"} />
                    </SidebarControlTrigger>
                </Popover.Trigger>

                <Popover.Content side="right" align="start" sideOffset={8} style={{ zIndex: 20 }}>
                    <SidebarControlContent>
                        <ActiveViewSwitchContent handleClose={() => setIsOpen(false)} />
                    </SidebarControlContent>
                </Popover.Content>
            </SidebarControlStyled>
        </Popover>
    );
};

export { ActiveViewSwitch };
